import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

// Async thunk to create branding preset
export const fetchAllBrandingPresets = createAsyncThunk(
	'branding/fetchAllBrandingPresets',
	async ({page = 1, limit = 10}, { rejectWithValue }) => {
		try {
			const url = window.location.href
			const link = url.includes('?') ? `?${url.split("?")[1]}&limit=${limit}&page=${page}` : `?limit=${limit}&page=${page}`;
			const res = await axiosInstance.get(`/branding/admin/fetch-all${link}`);
			return res.data;
		} catch (err) {
			return rejectWithValue(err.response?.data || err.message);
		}
	}
);

// Async thunk to fetch branding preset by ID
export const deleteBrandingSingle = createAsyncThunk(
	'branding/deleteBrandingSingle',
	async (id, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.delete(`/branding/admin/delete/${id}`);
			return res.data;
		} catch (err) {
			return rejectWithValue(err.response?.data || err.message);
		}
	}
);
export const deleteBulkBrandingPresets = createAsyncThunk(
	'branding/deleteBulkBrandingPresets',
	async (ids, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.delete(`/branding/admin/delete-bulk`, { data: { ids } });
			return res.data;
		} catch (err) {
			return rejectWithValue(err.response?.data || err.message);
		}
	}
);
export const deleteAllBrandingPresets = createAsyncThunk(
	'branding/deleteAllBrandingPresets',
	async (_, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.delete(`/branding/admin/delete-all`);
			return res.data;
		} catch (err) {
			return rejectWithValue(err.response?.data || err.message);
		}
	}
);

const brandingSlice = createSlice({
	name: 'branding',
	initialState: {
		presets: [],
		pagination: null,
		preset: null,
		loading: false,
		error: null,
	},
	reducers: {
		resetBranding: state => {
			state.preset = null;
			state.loading = false;
			state.error = null;
		}
	},
	extraReducers: builder => {
		builder
		.addCase(fetchAllBrandingPresets.pending, state => {
			state.loading = true;
			state.error = null;
		})
		.addCase(fetchAllBrandingPresets.fulfilled, (state, action) => {
			state.loading = false;
			state.presets = action.payload.presets;
			state.pagination = action.payload?.meta || null;
		})
		.addCase(fetchAllBrandingPresets.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload;
		})
		.addCase(deleteBrandingSingle.pending, state => {
			state.loading = true;
			state.error = null;
		})
		.addCase(deleteBrandingSingle.fulfilled, (state, action) => {
			state.loading = false;
			state.preset = action.payload?.preset;
			state.presets = state.presets.filter(p => p._id !== action.payload.id);
		})
		.addCase(deleteBrandingSingle.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		})
		.addCase(deleteBulkBrandingPresets.pending, state => {
			state.loading = true;
			state.error = null;
		})
		.addCase(deleteBulkBrandingPresets.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		})
		.addCase(deleteBulkBrandingPresets.fulfilled, (state, action) => {
			state.loading = false;
			state.presets = state.presets.filter(p => !action.payload.ids.includes(p._id));
		})
	}
});
export const { resetBranding } = brandingSlice.actions;
export default brandingSlice.reducer;